import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Homepage from "./screen/Homepage";
import 'bootstrap/dist/css/bootstrap.css'
import Apply from './screen/apply';
import ApplicationForm from './ApplicationForm';

function App() {
  return (
      <BrowserRouter>
          <Routes>
            <Route path={'/'} element={<Homepage/>}/>
            <Route path={'/apply'} element={<Apply/>}/>
            <Route path={'/apply1'} element={<ApplicationForm/>}/>

            
          </Routes>
      </BrowserRouter>
  );
}

export default App;
